import React from 'react';
import { connect } from 'react-redux';
import { isDefined } from '../../../../utils';
import CanvasJSChart from '../CanvasJSChart';

class GeneralAggregationChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { propId, data, toggleDataSeries, minX, maxX, suffixY } = this.props;

        const axisY = {
            title: "",
            suffix: "",
            lineColor: "#4F81BC",
            tickColor: "#4F81BC",
            labelFontColor: "#4F81BC",
            includeZero: true,
            gridColor: '#fff'
        };

        if (isDefined(maxX)) {
            axisY.maximum = maxX;
        }

        if (isDefined(suffixY)) {
            axisY.suffix = suffixY;
        }

        const options = {
            animationEnabled: true,
            exportEnabled: true,
            title: {
                text: "",
            },
            axisX: {
                //valueFormatString: "MMM",
                title: "",
                lineColor: "#4F81BC",
                labelFontColor: "#4F81BC",
                gridColor: '#fff'
            },
            axisY: axisY,
            toolTip: {
                shared: true
            },
            legend: {
                verticalAlign: "center",
                horizontalAlign: "right",
                cursor: "pointer",
                itemclick: toggleDataSeries
            },
            data: data
        };

        //colorSet={ }

        return (
            <CanvasJSChart
                chartContainerId={propId}
                options={options}
            />
        );
    }
}

const select = state => ({});

export default connect(select)(GeneralAggregationChart);